import { formatCents } from "@/lib/utils"
import { AcceptAction } from "./AcceptAction";
import { ApiResponseV2, ErrorResponse, QuoteResponse } from "@vertical-insure/shared";
import {QuoteActionDescription} from "@/components/ui/QuoteActionDescription";
import {DeclineAction} from "@/components/ui/DeclineAction";
import {DynamicHtmlElement} from "@/components/ui/DynamicHtmlElement";
import {ProductDescriptors} from "@/components/ui/ProductDescriptors";
import {FormError} from "@/components/ui/FormError";

export const ProductCardRadio = ({
  quote,
  product,
} : {
  quote: QuoteResponse | ErrorResponse | ApiResponseV2;
  product: string;
}) => {
  if (!('quote_id' in quote)) {
    return null;
  }

  const descriptors = quote.product.descriptors && quote.product.descriptors.length > 0
    ? quote.product.descriptors : quote.product.perils;

  return (
    <div className="flex flex-1 flex-col border p-2 rounded gap-2">
      <DynamicHtmlElement html={quote.product.promotional_header} className="text-md font-semibold" />
      <DynamicHtmlElement html={quote.product.promotional_description} className="text-sm" />
      <div className="flex flex-col md:flex-row xl:flex-col gap-2">
        <ProductDescriptors descriptors={descriptors ?? []} className="xl:grid xl:grid-cols-2"/>
        <div className="flex flex-1 flex-col gap-2 md:max-w-md md:min-w-md xl:max-w-full xl:min-w-full">
          <div className="flex flex-col gap-2 md:max-w-md md:min-w-md xl:max-w-full xl:min-w-full xl:flex-row">
            <AcceptAction type="radio" quoteId={quote.quote_id}>
              <div className="flex-1"><QuoteActionDescription product={product} quote={quote} /></div>
              <div className="font-medium">{formatCents(quote.total, quote.currency)}</div>
            </AcceptAction>
            <DeclineAction type="radio"/>
          </div>
          <FormError />
        </div>
      </div>
      <DynamicHtmlElement html={quote.product.legal_disclaimer} className="text-xs mt-2" />
    </div>
  )
}
